import { render, staticRenderFns } from "./regionContrast.vue?vue&type=template&id=34d644a8&scoped=true"
import script from "./regionContrast.vue?vue&type=script&lang=js"
export * from "./regionContrast.vue?vue&type=script&lang=js"
import style0 from "./regionContrast.vue?vue&type=style&index=0&id=34d644a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d644a8",
  null
  
)

export default component.exports